/** Thrown by the outreach wire mappers when Go sends a value this build has never heard of (spec §2.1b, FE wire
 *  boundary). A contract break, not a transient failure: retrying or refreshing cannot fix it. */
export type OutreachWireField = 'status' | 'outreach_state' | 'by_state' | 'removed_or_rejected';

export class OutreachWireError extends Error {
  readonly field: OutreachWireField;
  readonly value: unknown;
  /** The entry id for a row, or `counts` for the counts payload. */
  readonly subject: string;

  constructor(field: OutreachWireField, value: unknown, subject: string) {
    super(`Outreach ${subject === 'counts' ? 'counts' : `row ${subject}`} carries an unknown ${field}: ${JSON.stringify(value)}`);
    this.name = 'OutreachWireError';
    this.field = field;
    this.value = value;
    this.subject = subject;
  }
}

export const isOutreachWireError = (error: unknown): error is OutreachWireError => error instanceof OutreachWireError;
